import StartingPageContent from "../components/StartingPage/StartingPageContent";
const HomePage = () => {
  return <StartingPageContent pageName="Home Page" />;
};

export default HomePage;
